import { render } from "./PartnerPayPalPayMonthly.vue?vue&type=template&id=5b8d6884"
import script from "./PartnerPayPalPayMonthly.vue?vue&type=script&lang=js"
export * from "./PartnerPayPalPayMonthly.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__